import { render, staticRenderFns } from "./BattleAccount.vue?vue&type=template&id=0199d1d8&"
import script from "./BattleAccount.vue?vue&type=script&lang=js&"
export * from "./BattleAccount.vue?vue&type=script&lang=js&"
import style0 from "./BattleAccount.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports